import React, { useEffect } from "react";
import "./App.css";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useAuthStore } from "./stores/adminStore";

import Login from "./Pages/Login";
import Sidebar from "./components/Sidebar";

function App() {
  const { auth } = useAuthStore(); // auth is now a function
  const isLoggedIn = auth(); // Call the function to get the current auth state
  const navigate = useNavigate();

  console.log("App.js - auth:", isLoggedIn);

  // Redirect based on auth state
  useEffect(() => {
    console.log("App.js useEffect - auth:", isLoggedIn);
    if (isLoggedIn && window.location.pathname === "/login") {
      navigate("/", { replace: true });
    } else if (!isLoggedIn && window.location.pathname !== "/login") {
      navigate("/login", { replace: true });
    }
  }, [isLoggedIn, navigate]); // React to isLoggedIn changes

  return (
    <div className="app-container">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={isLoggedIn ? <Sidebar /> : <Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
}

export default App;